/* eslint-disable no-unused-vars */
import React,{useState,useEffect} from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Button, Tooltip } from 'antd';
import { getList } from '../Utils/FormCalls';
import { encode as base64_encode } from 'base-64';
import { MODELCOMPARSION } from '../../../commons/api';
import StyledTable from '../../../commons/styles/table';
import themeSettings from '../../../commons/styles/themeSettings.json';
// import {useNavigate} from 'react-router-dom';
const APIList = {
  getList: `${MODELCOMPARSION.GET}`
};
const BookmarksList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  // const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      let response = await getList(APIList.getList);
      setDataSource(response && Array.isArray(response) ? [...response] : []);
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);
  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const columns = [
    {
      title: translation('Model 1'),
      dataIndex: 'model 1',
      key: 'model 1',
      children: [
        {
          title: translation('Name'),
          dataIndex: 'modelName_1',
          key: 'modelName_1'
        },
        {
          title: translation('From Time'),
          dataIndex: 'model_1_FromTime',
          key: 'model_1_FromTime',
          render: (text) => ({
            children: text !== undefined && text !== null ? (
              <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
            ) : null
          })
        },
        {
          title: translation('To Time'),
          dataIndex: 'model_1_ToTime',
          key: 'model_1_ToTime',
          render: (text) => ({
            children: text !== undefined && text !== null ? (
              <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
            ) : null
          })
        },
        {
          title: translation('Status'),
          dataIndex: 'model_1_Status',
          key: 'model_1_Status'
        }
      ]
    },
    {
      title: translation('Model 2'),
      dataIndex: 'model 2',
      key: 'model 2',
      children: [
        {
          title: translation('Name'),
          dataIndex: 'modelName_2',
          key: 'modelName_2'
        },
        {
          title: translation('From Time'),
          dataIndex: 'model_2_FromTime',
          key: 'model_2_FromTime',
          render: (text) => ({
            children: text !== undefined && text !== null ? (
              <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
            ) : null
          })
        },
        {
          title: translation('To Time'),
          dataIndex: 'model_2_ToTime',
          key: 'model_2_ToTime',
          render: (text) => ({
            children: text !== undefined && text !== null ? (
              <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
            ) : null
          })
        },
        {
          title: translation('Status'),
          dataIndex: 'model_2_Status',
          key: 'model_2_Status'
        }
      ]
    },
    {
      title: translation('Created By'),
      dataIndex: 'modelCreatedName',
      key: 'modelCreatedName'
    },
    {
      title: translation('Created Date&Time'),
      dataIndex: 'model_1_CreatedTime',
      key: 'model_1_CreatedTime',
      render: (text) => ({
        children: text !== undefined && text !== null ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Action'),
      render: (text, record) => (
        <>
          <Tooltip
            title={
              record.model_1_Status === 'Completed' && record.model_2_Status === 'Completed'
                ? translation('View Results')
                : translation('View Results')
            }
          >
            <a
              style={{ marginRight: '5px' }}
              onClick={() =>
                props.navigate(`/rubus/RbsAnalytics/ModelComparision/${base64_encode(record.Id)}`)
              }
            >
              {record.model_1_Status === 'Completed' && record.model_2_Status === 'Completed'
                ? translation('View Results')
                : translation('View Results')}
            </a>
          </Tooltip>
        </>
      )
    }
  ];
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'right' }}>
        <Tooltip title={translation('Click here to register a new model')}>
        <Button
          type='primary'
          onClick={() => props.navigate('/rubus/RbsAnalytics/ModelComparision')}
          style={{
            marginBottom: 8
          }} 
          
        >
          {translation('New')}
        </Button>
        </Tooltip>
      </div>
      <StyledTable size="small"
        data-testid="workbenchList"
        theme={themeSettings}
        dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
        columns={columns}
      />
    </>
  );
};
const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(BookmarksList);
